import { constructEnum } from '@/lib/enum';

export default constructEnum('LandingPageSectionType', {
  COUPONS: 10,
  PRODUCT_RECOMMENDATIONS: 20,
  CARTS: 30,
  UNPAID_ORDERS: 40
});
